import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Topic";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const GetTopicItemTypes = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetTopicItemTypes`, options);

export const UpdateTopicOrders = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateTopicOrders`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  GetTopicItemTypes,
  UpdateTopicOrders,
};
